export const getDataPayments = async (ci) => {
  const url = `${process.env.REACT_APP_PAYMENTS_API_URL}${ci}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Token ${process.env.REACT_APP_PAYMENTS_API_TOKEN_ACCESS}`,
    },
  })
    .then((res) => res.json())
    .catch((error) => console.error("Error:", error))
    .then((response) => {
      return response;
    });
  return response;
};
